import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string; error?: string | boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      dropdownContainer: {
        display: 'flex',
        padding: '0px 40px',
        background: 'transparent',
        borderRadius: '50px',
        border: props.error ? '1px solid #FF1919' : '1px solid #DDDDDD',
        boxShadow: 'none',
        alignItems: 'center',
        '&:hover': {
          boxShadow: `inset 0 0 10px 0 rgb(0 0 0 / 15%)`
        }
      },
      dropdown: {
        height: '100%',
        minHeight: '104px',
        alignContent: 'center',
        width: '100%',
        background: 'transparent',
        fontSize: '40px',
        fontFamily: props.fontFamily,
        fontWeight: 600,
        '& > .MuiSelect-select:focus': {
          backgroundColor: 'transparent'
        },
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      },
      dropdownItem: {
        height: '80px',
        width: '100%',
        margin: '1px 1px 1px 1px',
        fontFamily: props.fontFamily,
        fontSize: '40px',
        fontWeight: 600,
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      },
      inputLabel: {
        fontFamily: props.fontFamily,
        fontWeight: 600,
        fontSize: '40px',
        padding: '0px 24px',
        color: '#2A2A2A',
        marginBottom: '10px',
        lineHeight: '36px'
      }
    })
  );
